import { Breakpoint } from "../hooks";

/**
 * Creates a function that returns a css class list with the default and
 * the corresponding breakpoint prefixed css class depending on a breakpoint
 * asked for.
 *
 * The reason we write out the whole class name is so the tailwind classes are not pruned.
 * For example
 * const fn = createBreakpointClassMatcher('sm:block', 'md:block');
 * fn('hidden', 'md') // returns 'hidden md:block'
 * @param args
 */
export function createBreakpointClassSelector(...args: string[]) {
  return (breakpoint?: Breakpoint): string => {
    if (!breakpoint) return "";
    return args
      .filter(
        (x) => x.startsWith(`${breakpoint}:`) || x.includes(":") === false
      )
      .join(" ");
  };
}
//
